import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { JwtService } from '@gray/domain/http/jwt.service';

@Injectable({providedIn: 'root'})
export class CoachAuthGuard {
  constructor(
    private router: Router,
    private jwtService: JwtService,
  ) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const token = this.jwtService.getToken();
    if (token && (token.length > 3)) {
      return true;
    }

    this.router.navigateByUrl(`/auth/login?redirectTo=${state.url}`);
    return false;
  }
}
